import { Tooltip } from "@mui/material";

export const actionRequiredCodes = [
	{ Code: "N", Name: "None", Color: "#009460" }, // Green
	{ Code: "S", Name: "Soft Change", Color: "#fad215" }, // Yellow
	{ Code: "F", Name: "Full Change", Color: "#ce2029" }, // Red
];

type StatusTagProps = {
	status: { Code: string; Name: string };
};
export const ActionRequiredTag = ({ status }: StatusTagProps) => {
	if (!status || !status.Code || !status.Name) {
		return null;
	}
	const backgroundColor = actionRequiredCodes.find((code) => code.Color)?.Color;

	return (
		<Tooltip title={status.Name} arrow>
			<div
				style={{
					width: "26px",
					height: "26px",
					borderRadius: 4,
					display: "inline-flex",
					alignItems: "center",
					justifyContent: "center",
					color: "#fff",
					fontWeight: "bold",
					backgroundColor,
				}}
			>
				{status.Code.charAt(0).toUpperCase()}
			</div>
		</Tooltip>
	);
};
